import React from 'react'
import { AllRoutes } from './Routes'

export default function App() {

  return (
    <AllRoutes />
  )
}
